export const COUNTRY_LBLS: Record<string, string> = {
  us: 'United States', gb: 'United Kingdom', ca: 'Canada', au: 'Australia',
  de: 'Germany', fr: 'France', es: 'Spain', it: 'Italy', nl: 'Netherlands',
  be: 'Belgium', se: 'Sweden', no: 'Norway', dk: 'Denmark', fi: 'Finland',
  pl: 'Poland', cz: 'Czech Republic', at: 'Austria', ch: 'Switzerland',
  pt: 'Portugal', gr: 'Greece', ie: 'Ireland', il: 'Israel',
  ae: 'United Arab Emirates', sa: 'Saudi Arabia', jp: 'Japan',
  kr: 'South Korea', sg: 'Singapore', in: 'India', br: 'Brazil',
  mx: 'Mexico', ar: 'Argentina', cl: 'Chile', co: 'Colombia',
  za: 'South Africa', nz: 'New Zealand',
}

export const country_ids = Object.keys(COUNTRY_LBLS)
  .sort((a, b) => COUNTRY_LBLS[a].localeCompare(COUNTRY_LBLS[b]))

export const country_id2lbl = (id: string | null | undefined): string =>
  id && COUNTRY_LBLS[id] || ''